var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstructionWizard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 456,
    viewBox: "0 0 440 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6162_77014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6162_77014",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 440,
    height: 456
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 0H0V456H440V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6162_77014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220 446.687C341.499 446.687 440 346.689 440 223.344C440 99.9981 341.509 0 220 0C98.4911 0 0 99.9981 0 223.344C0 346.689 98.5011 446.687 220 446.687Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.153 218.127H128.515C126.866 218.127 125.524 216.765 125.524 215.09V15.3968C125.524 13.722 126.866 12.3599 128.515 12.3599H415.153C416.803 12.3599 418.145 13.722 418.145 15.3968V215.09C418.145 216.765 416.803 218.127 415.153 218.127Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.168 19.4629H135.244C134.419 19.4629 133.743 20.149 133.743 20.9864V28.2005C133.743 29.0379 134.419 29.724 135.244 29.724H157.168C157.993 29.724 158.669 29.0379 158.669 28.2005V20.9864C158.669 20.149 157.993 19.4629 157.168 19.4629Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.467 45.8975H134.946C134.28 45.8975 133.743 46.4423 133.743 47.1183V50.236C133.743 50.912 134.28 51.4568 134.946 51.4568H157.467C158.132 51.4568 158.669 50.912 158.669 50.236V47.1183C158.669 46.4423 158.132 45.8975 157.467 45.8975Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.467 62.6968H134.946C134.28 62.6968 133.743 63.2416 133.743 63.9176V67.0353C133.743 67.7113 134.28 68.2562 134.946 68.2562H157.467C158.132 68.2562 158.669 67.7113 158.669 67.0353V63.9176C158.669 63.2416 158.132 62.6968 157.467 62.6968Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.467 79.4858H134.946C134.28 79.4858 133.743 80.0307 133.743 80.7067V83.8244C133.743 84.5004 134.28 85.0452 134.946 85.0452H157.467C158.132 85.0452 158.669 84.5004 158.669 83.8244V80.7067C158.669 80.0307 158.132 79.4858 157.467 79.4858Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.779 29.7241H418.145",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.223 49.5601H188.415C187.59 49.5601 186.915 50.2462 186.915 51.0836V148.347C186.915 149.185 187.59 149.871 188.415 149.871H284.223C285.048 149.871 285.724 149.185 285.724 148.347V51.0836C285.724 50.2462 285.048 49.5601 284.223 49.5601Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.296 49.5601H299.489C298.664 49.5601 297.988 50.2462 297.988 51.0836V148.347C297.988 149.185 298.664 149.871 299.489 149.871H395.296C396.121 149.871 396.797 149.185 396.797 148.347V51.0836C396.797 50.2462 396.121 49.5601 395.296 49.5601Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.296 162.312H299.489C298.664 162.312 297.988 162.998 297.988 163.835V201.429C297.988 202.266 298.664 202.952 299.489 202.952H395.296C396.121 202.952 396.797 202.266 396.797 201.429V163.835C396.797 162.998 396.121 162.312 395.296 162.312Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.745 173.793H332.077",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.745 182.43H385.288",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.745 191.37H385.288",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.223 162.312H188.415C187.59 162.312 186.915 162.998 186.915 163.835V201.429C186.915 202.266 187.59 202.952 188.415 202.952H284.223C285.048 202.952 285.724 202.266 285.724 201.429V163.835C285.724 162.998 285.048 162.312 284.223 162.312Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.662 173.793H221.004",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.662 182.43H274.205",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.662 191.37H274.205",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.906 66.5513C197.489 66.5513 203.641 60.3058 203.641 52.6074C203.641 44.909 197.489 38.6636 189.906 38.6636C182.323 38.6636 176.171 44.909 176.171 52.6074C176.171 60.3058 182.323 66.5513 189.906 66.5513Z",
    fill: "#0058BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.805 66.5513C401.389 66.5513 407.54 60.3058 407.54 52.6074C407.54 44.909 401.389 38.6636 393.805 38.6636C386.222 38.6636 380.07 44.909 380.07 52.6074C380.07 60.3058 386.222 66.5513 393.805 66.5513Z",
    fill: "#0058BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.619 52.5566L188.177 56.1687L195.193 49.0454",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.297 56.1687L397.314 49.0454",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.314 56.1687L390.297 49.0454",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.264 103.751V95.6797C245.264 94.9634 244.886 94.2975 244.27 93.9342L237.313 89.8984C236.697 89.5352 235.942 89.5352 235.325 89.8984L228.368 93.9342C227.752 94.2975 227.375 94.9634 227.375 95.6797V103.751C227.375 104.468 227.752 105.134 228.368 105.497L235.325 109.533C235.942 109.896 236.697 109.896 237.313 109.533L244.27 105.497C244.886 105.134 245.264 104.468 245.264 103.751Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.663 94.6709L236.319 99.7157L244.976 94.6709",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.319 109.805V99.7158",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.337 103.751V95.6797C356.337 94.9634 355.959 94.2975 355.343 93.9342L348.386 89.8984C347.77 89.5352 347.015 89.5352 346.399 89.8984L339.442 93.9342C338.825 94.2975 338.448 94.9634 338.448 95.6797V103.751C338.448 104.468 338.825 105.134 339.442 105.497L346.399 109.533C347.015 109.896 347.77 109.896 348.386 109.533L355.343 105.497C355.959 105.134 356.337 104.468 356.337 103.751Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.736 94.6709L347.392 99.7157L356.049 94.6709",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.393 109.805V99.7158",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.779 218.127V12.3599",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.083 452.953C132.083 452.953 132.203 455.455 133.107 455.455C134.012 455.455 168.816 455.819 169.174 455.455C169.532 455.092 170.347 454.043 170.287 452.953H132.083Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.735 445.325C144.735 445.325 147.796 438.353 157.566 438.676C171.142 439.12 170.297 452.953 170.297 452.953H132.093V424.45H152.11L152.239 439.342",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.735 445.325C144.735 445.325 147.796 438.353 157.566 438.676C171.142 439.12 170.297 452.953 170.297 452.953H132.093V424.45H152.11L152.239 439.342",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.766 433.813C152.766 433.813 155.568 427.921 158.421 429.414C161.273 430.917 156.95 433.712 152.766 433.813Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.766 433.813L156.97 437.415",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.766 433.813C152.766 433.813 149.963 427.921 147.111 429.414C144.258 430.917 148.582 433.712 152.766 433.813Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.766 433.813L148.562 437.415",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.779 164.834L190.105 217.663L176.718 234.452L154.425 210.742L153.77 164.834H153.779Z",
    fill: "#0058BB",
    stroke: "#0058BB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4292 161.959C74.6484 159.144 82.9571 156.732 97.1891 154.946C97.1891 154.946 101.035 165.238 114.512 164.753C127.979 164.269 129.161 155.32 129.161 155.32C129.161 155.32 139.895 157.196 146.206 159.941C149.446 161.353 152.646 163.27 154.485 165.702C157.566 169.768 158.152 174.449 158.152 174.449C158.152 174.449 156.145 241.293 155.697 273.671L72.5116 283.609L62.4439 214.979C62.4439 214.979 54.334 166.711 66.4292 161.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7202 280.673L79.8859 425.963H106.75L118.944 308.934L129.042 425.963H156.065L155.707 273.681L72.7202 280.673Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.148 196.253L62.2153 199.472L63.7856 219.308L157.148 215.322V196.253Z",
    fill: "#B9E7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1925 260.988L155.887 257.558L156.036 240.113L66.5786 243.341L69.1925 260.988Z",
    fill: "#B9E7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9734 161.131C77.1926 158.316 78.8722 157.882 97.189 154.946C97.189 154.946 101.045 165.238 114.522 164.753C127.989 164.269 129.161 155.32 129.161 155.32C129.161 155.32 143.393 157.206 151.513 162.806C153.779 164.37 155.459 166.681 156.453 169.274C157.675 172.482 158.341 174.288 158.122 181.421C156.562 232.445 155.707 273.661 155.707 273.661L72.7202 280.653L58.1404 214.707C58.1404 214.707 56.8881 165.863 68.9833 161.111",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.189 154.946L117.344 197.282L129.161 155.32C129.161 155.32 115.714 171.483 97.189 154.946Z",
    fill: "#0058BB",
    stroke: "#0058BB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.945 281.147V300.358",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8315 453.104C83.8315 453.104 83.9409 455.465 84.7956 455.465C85.6503 455.465 118.467 455.809 118.805 455.465C119.143 455.122 119.918 454.134 119.859 453.104H83.8315Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7481 445.911C95.7481 445.911 98.6302 439.332 107.843 439.645C120.644 440.069 119.849 453.104 119.849 453.104H83.8218V426.236H102.695L102.814 440.27",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7481 445.911C95.7481 445.911 98.6302 439.332 107.843 439.645C120.644 440.069 119.849 453.104 119.849 453.104H83.8218V426.236H102.695L102.814 440.27",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.765 433.813C102.765 433.813 105.567 427.921 108.42 429.414C111.272 430.917 106.949 433.712 102.765 433.813Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.765 433.813L106.959 437.415",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.765 433.813C102.765 433.813 99.9622 427.921 97.1098 429.414C94.2574 430.917 98.5807 433.712 102.765 433.813Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.765 433.813L98.5605 437.415",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.377 279.785C144.377 279.785 143.463 296.625 155.687 298.078",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.364 197.837L118.944 281.147",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.748 445.91C95.748 445.91 97.4774 442.107 102.089 440.492",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.222 270.371C103.222 270.371 115.536 282.247 117.385 285.809C119.243 289.38 116.669 291.186 114.89 290.278C114.89 290.278 115.854 294.395 112.008 293.134C112.008 293.134 112.147 297.069 108.45 295.727C108.45 295.727 107.376 298.864 104.703 296.978C102.03 295.091 98.5311 290.49 97.4081 288.765C96.9211 288.018 93.542 277.636 93.542 277.636L103.212 270.361L103.222 270.371Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.765 375.091H223.3V454.749H301.765V375.091Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.772 375.444H255.282V403.342H269.772V375.444Z",
    fill: "#0058BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.717 295.121H263.252V374.779H341.717V295.121Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.765 375.091H378.938C379.653 375.091 380.23 375.676 380.23 376.403V453.437C380.23 454.164 379.653 454.749 378.938 454.749H301.765V375.091Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.247 375.444H333.757V403.342H348.247V375.444Z",
    fill: "#0058BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.253 295.121L231.449 262.824",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.531 262.824L341.728 295.121",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.878 305.614H307.996V318.246H331.878V305.614Z",
    fill: "#B9E7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.001 294.798H271.859L263.282 256.69C263.004 255.459 263.928 254.289 265.171 254.289H339.69C340.932 254.289 341.856 255.459 341.578 256.69L333.001 294.798Z",
    fill: "#0058BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.431 268.737V243.947C289.431 235.31 295.245 228.308 302.43 228.308C309.616 228.308 315.43 235.31 315.43 243.947V268.737",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.116 260.998H314.734C314.337 260.998 314.019 261.321 314.019 261.725V268.707C314.019 269.11 314.337 269.433 314.734 269.433H316.116C316.513 269.433 316.831 269.11 316.831 268.707V261.725C316.831 261.321 316.513 260.998 316.116 260.998Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.117 260.998H288.735C288.338 260.998 288.02 261.321 288.02 261.725V268.707C288.02 269.11 288.338 269.433 288.735 269.433H290.117C290.514 269.433 290.832 269.11 290.832 268.707V261.725C290.832 261.321 290.514 260.998 290.117 260.998Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.208 229.176L197.4 205.485C196.366 204.607 194.825 204.739 193.951 205.788L161.472 245.087C160.607 246.136 160.736 247.7 161.77 248.588L189.578 272.278C190.612 273.156 192.152 273.025 193.027 271.976L225.506 232.677C226.37 231.627 226.241 230.064 225.208 229.176Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.626 234.129L193.375 210.913L167.435 242.302L194.687 265.518L220.626 234.129Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.457 259.121C179.58 259.121 180.484 258.203 180.484 257.063C180.484 255.923 179.58 255.005 178.457 255.005C177.334 255.005 176.429 255.923 176.429 257.063C176.429 258.203 177.334 259.121 178.457 259.121Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.278 238.932L190.264 220.175C190.145 220.074 189.966 220.095 189.876 220.206L176.867 235.945C176.767 236.066 176.787 236.238 176.897 236.339L198.91 255.095C199.03 255.196 199.199 255.176 199.298 255.065L212.308 239.325C212.407 239.204 212.387 239.033 212.278 238.932Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.162 247.297L174.581 239.134C174.471 239.043 174.312 239.053 174.213 239.164L172.593 241.132C172.504 241.243 172.514 241.404 172.623 241.505L182.204 249.668C182.313 249.758 182.472 249.748 182.571 249.637L184.191 247.67C184.281 247.559 184.271 247.397 184.162 247.297Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.614 257.911L187.024 249.748C186.914 249.658 186.755 249.668 186.656 249.779L185.036 251.746C184.947 251.857 184.956 252.018 185.066 252.119L194.656 260.282C194.766 260.373 194.925 260.363 195.024 260.252L196.644 258.284C196.734 258.173 196.724 258.012 196.614 257.911Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.659 216.826L204.168 226.623",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.376 241.353L198.503 238.781C198.692 238.549 198.751 238.236 198.642 237.953L197.489 234.775C197.39 234.493 197.151 234.291 196.853 234.23L193.573 233.625C193.285 233.574 192.987 233.685 192.798 233.907L190.671 236.48C190.482 236.712 190.423 237.025 190.532 237.308L191.685 240.486C191.784 240.768 192.023 240.97 192.321 241.031L195.601 241.636C195.889 241.686 196.187 241.575 196.376 241.353Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.156 233.666L194.587 237.631L198.682 238.377",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.923 240.849L194.587 237.63",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7746 161.272C53.9662 167.104 50.8753 184.065 49.7621 201.076C48.7882 215.786 46.1942 236.218 59.8001 251.453C78.3653 272.248 90.0034 283.972 90.0034 283.972C93.5415 280.673 106.78 269.947 106.78 269.947C106.78 269.947 76.795 230.225 76.4174 229.599C71.8456 221.911 80.3133 205.283 78.6535 188.222C76.9242 170.383 68.7746 161.262 68.7746 161.262V161.272Z",
    fill: "#0058BB",
    stroke: "#0058BB",
    strokeWidth: 0.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.49 126.403C137.49 126.403 140.502 143.091 146.216 149.538C146.306 149.629 146.306 149.791 146.196 149.871C145.232 150.668 140.273 154.28 129.519 154.977L127.253 142.95C127.253 142.95 131.607 139.055 137.5 126.413L137.49 126.403Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.51 154.967L127.244 142.94C127.244 142.94 120.674 144.12 114.94 138.702C109.195 133.274 105.846 126.403 105.846 126.403L96.9707 154.967C96.9707 154.967 101.413 164.057 114.622 162.877C127.83 161.696 129.51 154.967 129.51 154.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.51 154.967L127.244 142.94C127.244 142.94 120.674 144.12 114.94 138.702C109.195 133.274 105.846 126.403 105.846 126.403L96.9707 154.967C96.9707 154.967 101.413 164.057 114.622 162.877C127.83 161.696 129.51 154.967 129.51 154.967ZM129.51 154.967H129.5",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.495 123.214L96.9606 154.956C96.9606 154.956 79.9955 152.393 71.5477 135.887C71.4583 135.715 71.5278 135.493 71.7067 135.433C73.8336 134.575 85.7499 129.429 91.882 120.117C97.4178 111.732 102.198 103.519 103.391 100.291C103.391 100.291 111.888 104.286 114.92 105.86",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.495 123.214L96.9606 154.956C96.9606 154.956 79.9955 152.393 71.5477 135.887C71.4583 135.715 71.5278 135.493 71.7067 135.433C73.8336 134.575 85.7499 129.429 91.882 120.117C97.4178 111.732 102.198 103.519 103.391 100.291C103.391 100.291 111.888 104.286 114.92 105.86",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.722 110.431C143.722 110.431 137.063 131.73 131.159 139.852C128.237 143.868 124.212 142.99 122.672 142.778C117.832 142.133 112.674 139.217 106.035 127.614L108.529 121.237C108.529 121.237 106.253 119.34 105.786 117.322C105.319 115.304 106.015 113.256 107.118 112.741C108.42 112.136 110.04 112.852 111.213 114.638L114.94 105.86C114.94 105.86 126.081 113.155 143.732 110.431H143.722Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.361 126.372L126.578 127.331C127.005 127.512 127.502 127.331 127.681 126.887C128.446 125.131 129.629 121.68 131.149 117.292",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.361 126.372L126.578 127.331C127.005 127.512 127.502 127.331 127.681 126.887C128.446 125.131 129.629 121.68 131.149 117.292",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.333 134.272C125.812 134.848 124.699 134.575 123.437 134C121.966 133.334 120.684 132.144 119.69 131.003",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.333 134.272C125.812 134.848 124.699 134.575 123.437 134C121.966 133.334 120.684 132.144 119.69 131.003",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.64 117.705C124.192 117.705 123.834 117.342 123.834 116.898C123.834 116.454 124.192 116.091 124.64 116.091C125.087 116.091 125.435 116.454 125.435 116.898C125.435 117.342 125.077 117.705 124.64 117.705Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.707 120.571C134.27 120.571 133.912 120.208 133.912 119.764C133.912 119.32 134.27 118.957 134.707 118.957C135.144 118.957 135.512 119.32 135.512 119.764C135.512 120.208 135.154 120.571 134.707 120.571Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9718 97.0319C99.9718 97.0319 111.759 108.282 131.348 113.438C139.398 115.546 144.437 116.525 147.041 116.888C148.76 117.13 150.331 113.296 148.452 111.591C147.826 111.016 146.614 110.421 144.357 109.866C144.357 109.866 150.837 87.9513 129.35 81.3426C111.431 75.8235 101.9 92.0678 99.9619 97.042L99.9718 97.0319Z",
    fill: "#0058BB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6162_77014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 456,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionWizard);
export default __webpack_public_path__ + "static/media/instruction_wizard.1fe34eba81c99c0cbd4a2bed49a82c89.svg";
export { ForwardRef as ReactComponent };